/**
 * Centralized translations for Evaluation module
 * Contains all labels used across requirements and indicators evaluation components
 */

export const EvaluationLabels = {
    it: {
        // Navigation and breadcrumb
        home: 'Home',
        requirements: 'Requisiti',
        
        // Main titles and headers
        aiPlan: 'AI Plan',
        chooseYourFile: 'Scegli il tuo file',
        
        // Actions and buttons
        close: 'Chiudi',
        save: 'Salva',
        saveData: 'Salva i dati',
        openSearchFiles: 'Apri ricerca file e cartelle nel tuo dms',
        
        // Alert and modal titles
        error: 'ERRORE',
        success: 'Successo',
        info: 'INFO',
        saving: 'Salvataggio',
        addingFile: 'Aggiunta file',
        
        // Messages
        addingFileMessage: 'Aggiunta file {{fileName}} a questa valutazione',
        addedFile: 'Aggiunto {{fileName}}',
        problemAdding: 'Problema nell\'aggiunta di {{fileName}}',
        
        // Level labels for indicators
        pointOfAttention: 'PUNTO DI ATTENZIONE',
        aspectToBeConsidered: 'ASPETTO DA CONSIDERARE'
    },
    
    en: {
        // Navigation and breadcrumb
        home: 'Home',
        requirements: 'Requirements',
        
        // Main titles and headers
        aiPlan: 'AI Plan',
        chooseYourFile: 'Choose your file',
        
        // Actions and buttons
        close: 'Close',
        save: 'Save',
        saveData: 'Save data',
        openSearchFiles: 'Open search files and folder in your dms',
        
        // Alert and modal titles
        error: 'ERROR',
        success: 'Success',
        info: 'INFO',
        saving: 'Saving',
        addingFile: 'Adding file',
        
        // Messages
        addingFileMessage: 'Adding file {{fileName}} to this evaluation',
        addedFile: 'Added {{fileName}}',
        problemAdding: 'Problem adding {{fileName}}',
        
        // Level labels for indicators
        pointOfAttention: 'POINT OF ATTENTION',
        aspectToBeConsidered: 'ASPECT TO BE CONSIDERED'
    }
};